import { Notifications } from "d-react-components";
import { map } from "lodash";
import React, { useContext, useRef } from "react";
import AppContext from "@helpers/context";
import SerialNumberAPI from "@network/api/serial-number";
import ActivitiesView from "@components/order/components/activity/ActivitiesView";
import { useTranslation } from "react-i18next";

const SerialNumberActivity = () => {
  const { serialDetail } = useContext(AppContext);
  const activityList = useRef(null);
  const { t } = useTranslation();

  const source = (paging: any) => {
    const body = { id: serialDetail?.id };
    return SerialNumberAPI.activityList(paging, body);
  };

  const transformer = (res: any) => {
    const activityList = res?.data?.data?.activities ?? [];
    return map(activityList, (item) => ({
      ...item,
      files: map(item.attachment, (attItem) => attItem?.attachment),
    }));
  };

  const onClickSendComment = (comment: any, attachment: any) => {
    const body = {
      id: serialDetail?.id,
      comment,
      attachment: map(attachment, (item) => item?.key),
    };
    return SerialNumberAPI.activityAdd(body).then(() => {
      Notifications.showSuccess(t("addCommentSuccess"));
    });
  };

  return (
    <ActivitiesView
      className="mt-2"
      hideType
      source={source}
      transformer={transformer}
      setRef={(listRefParams: any) => (activityList.current = listRefParams)}
      onClickSendComment={onClickSendComment}
      isInstantUploadAttach
    />
  );
};

export default SerialNumberActivity;
